import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import MuiExpansionPanel from '@material-ui/core/ExpansionPanel';
import MuiExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import MuiExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { expansionPanelStyle } from '../utils/styles'
import { useLocation, withRouter } from 'react-router-dom'

const ExpansionPanel = withStyles({
  ...expansionPanelStyle
})(MuiExpansionPanel);

const ExpansionPanelSummary = withStyles({
  root: {
    border: 'none',
    minHeight: 56,
    '&$expanded': {
      minHeight: 56,
    },
    '&.root': {
      backgroundColor: 'white'
    }
  },
  content: {
    '&$expanded': {
      margin: '12px 0',
    },
  },
  expanded: {},
})(MuiExpansionPanelSummary);

const ExpansionPanelDetails = withStyles(theme => ({
  root: {
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
  },
}))(MuiExpansionPanelDetails);

const StyledSideBarItem = ({ parentIndex, childrenIndex, label, children, backgroundColor = false, isSelected, thisTrailId, currentTrailId }) => {
  const [expanded, setExpanded] = useState();
  const [expandedParent, setExpandedParent] = useState()
  const [expandedChildren, setExpandedChildren] = useState()
  const { pathname } = useLocation()

  const handleChange = panel => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : '')
    if (isSelected) {
      isSelected(newExpanded ? true : false)
    }
  }

  useEffect(() => {
    if (currentTrailId !== thisTrailId) {
      setExpanded('')
    } else {
      handleChange(`panel${expandedParent}`)
    }

  }, [currentTrailId]) // eslint-disable-line

  useEffect(() => {
    setExpanded(`panel${parentIndex !== -1 ? parentIndex : ''}`)
    setExpandedParent(parentIndex)
    setExpandedChildren(childrenIndex)
  }, [pathname]) // eslint-disable-line

  const getPanelStyle = () => {
    return backgroundColor ? { backgroundColor } : {}
  }

  return (
    <ExpansionPanel square expanded={expanded === `panel${expandedParent}`} style={{ ...getPanelStyle() }} onChange={handleChange(`panel${expandedParent}`)}>
      <ExpansionPanelSummary aria-controls={`panel${expandedChildren}-content`} id={`panel${expandedChildren}-header`} expandIcon={<ExpandMoreIcon />}>
        <Typography>{label}</Typography>
      </ExpansionPanelSummary>
      <ExpansionPanelDetails>
        {children}
      </ExpansionPanelDetails>
    </ExpansionPanel>
  )
}

export default withRouter(StyledSideBarItem)